module.exports = "/assets/data/59269cc346b7a9ae14d161558b9dc13a-G12.data.json";